









import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class FormBox extends Vue {
  @Prop() public title!: string;
}
